module.exports = __webpack_public_path__ + "fonts/line-awesome.452a5b42.woff2";